import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
  selector: 'app-subscription-plans',
  templateUrl: './subscription-plans.component.html',
  styleUrls: ['./subscription-plans.component.scss']
})
export class SubscriptionPlansComponent implements OnInit {

  plans: any = [];
  present_plan: any = {};
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SubscriptionPlansComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    if(this.data?.plans?.length) {
      this.plans = this.data.plans;
      this.plans = _.orderBy(this.plans, 'price')
      this.present_plan = this.data.present_plan
    }
  }

  onSelectingPlan(plan) {
    this.dialogRef.close({
      plan: plan
    })
  }

  onClose() {
    this.dialogRef.close()
  }

}
